import { render, staticRenderFns } from "./DailyCut.vue?vue&type=template&id=8d8bdaea&"
import script from "./DailyCut.vue?vue&type=script&lang=js&"
export * from "./DailyCut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QIcon,QPopupProxy,QDate,QBtn,QTable,QCheckbox,QTh,QTd,QTr,QDialog,QCard,QCardSection,QSeparator,QCardActions,QSelect,ClosePopup} from 'quasar'
component.options.components = Object.assign({QInput,QIcon,QPopupProxy,QDate,QBtn,QTable,QCheckbox,QTh,QTd,QTr,QDialog,QCard,QCardSection,QSeparator,QCardActions,QSelect}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
